var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebookWhite = function SvgFacebookWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 45,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.002,
    cy: 22.783,
    r: 21.318,
    stroke: "#9A9B9C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M23.42 20.63v-2.073c0-.572.44-1.036.982-1.036h.982V14.93H23.42c-1.627 0-2.946 1.392-2.946 3.109v2.59h-1.963v2.592h1.963v8.29h2.946v-8.29h1.963l.982-2.591H23.42Z"
  })));
};
export { SvgFacebookWhite as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNDUiIHZpZXdCb3g9IjAgMCA0NCA0NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjIuMDAxOCIgY3k9IjIyLjc4MyIgcj0iMjEuMzE4MiIgc3Ryb2tlPSIjOUE5QjlDIi8+CjxwYXRoIGQ9Ik0yMy40MTk4IDIwLjYyOTdWMTguNTU3QzIzLjQxOTggMTcuOTg0OSAyMy44NTk3IDE3LjUyMDYgMjQuNDAxNiAxNy41MjA2SDI1LjM4MzVWMTQuOTI5N0gyMy40MTk4QzIxLjc5MyAxNC45Mjk3IDIwLjQ3NDQgMTYuMzIxNSAyMC40NzQ0IDE4LjAzODhWMjAuNjI5N0gxOC41MTA3VjIzLjIyMDZIMjAuNDc0NFYzMS41MTE1SDIzLjQxOThWMjMuMjIwNkgyNS4zODM1TDI2LjM2NTMgMjAuNjI5N0gyMy40MTk4WiIgZmlsbD0iIzE4MTgxOCIvPgo8L3N2Zz4K";